// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__3aDHn","nameAndToolbar":"Overview_nameAndToolbar__1B_0c","name":"Overview_name__3P1wH","me":"Overview_me__3b9NY"};